// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { Store } from 'antd/lib/form/interface';
import { Form, FormInstance } from 'antd';
import { WidgetOutput, RadarWidgetType, FilterInput, ObjectTypeV1 } from 'thehive-sdk';
import DividerBasics from '@Organisms/Dashboard/WidgetManage/WidgetFormCommon/DividerBasics';
import DividerFilter from '@Organisms/Dashboard/WidgetManage/WidgetFormCommon/DividerFilter';
import ProvidedWidgetFormFilter from '@Organisms/Dashboard/WidgetManage/WidgetFormFilter/ProvidedWidgetFormFilter';
import TitleField from '@Organisms/Dashboard/WidgetManage/WidgetFormField/TitleField';
import EntityField from '@Organisms/Dashboard/WidgetManage/WidgetFormField/EntityField';
import { useLocalMessage } from '@Helpers/locale';
import { THForm } from '@Molecules/THForm/THForm';
import { FormSubmitButton } from '@Atoms/Buttons/FormSubmitButton/FormSubmitButton';
import { entitiesToExclude } from '@Constants/dashboard';

export interface RadarValues extends Store {
    title: string;
    entity: ObjectTypeV1;
    category: string;
    filters: FilterInput[];
    periodDateField?: string;
}

interface RadarFormProps {
    onFinish: (values: RadarValues) => void;
    defaultValues?: WidgetOutput & { options: RadarWidgetType };
    form: FormInstance;
    isValid?: boolean;
    onCancel: () => void;
    onChange: () => void;
}

export const RadarForm = ({
    onFinish,
    defaultValues,
    form,
    onCancel,
    onChange,
}: RadarFormProps): ReactElement | null => {
    const i = useLocalMessage();
    const entity = Form.useWatch(['entity'], form);
    const { options } = defaultValues || {};

    return (
        <THForm<RadarValues>
            name="radar-form"
            form={form}
            onFinish={onFinish}
            onValuesChange={onChange}
            initialValues={{
                title: options?.title,
                entity: options?.entity,
                category: options?.field,
                filters: options?.filters,
                periodDateField: options?.periodDateField || '_createdAt',
            }}
        >
            <THForm.Layout
                footer={<FormSubmitButton onCancel={onCancel} disabled={false} footerText={i('general.confirm')} />}
            >
                <DividerBasics />
                <TitleField />
                <EntityField form={form} showCategory showPeriodDate entitiesToExclude={entitiesToExclude} />
                <DividerFilter />

                <THForm.Item name="filters">
                    <ProvidedWidgetFormFilter entity={entity} />
                </THForm.Item>
            </THForm.Layout>
        </THForm>
    );
};
